module.exports = __webpack_public_path__ + "static/seesaw-2-922296c4277ace6ff57ce73d5c30075e.gif";